import { render, staticRenderFns } from "./GuestBox.vue?vue&type=template&id=d5f8dbd6&scoped=true&"
import script from "./GuestBox.vue?vue&type=script&lang=js&"
export * from "./GuestBox.vue?vue&type=script&lang=js&"
import style0 from "./GuestBox.vue?vue&type=style&index=0&id=d5f8dbd6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5f8dbd6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d5f8dbd6')) {
      api.createRecord('d5f8dbd6', component.options)
    } else {
      api.reload('d5f8dbd6', component.options)
    }
    module.hot.accept("./GuestBox.vue?vue&type=template&id=d5f8dbd6&scoped=true&", function () {
      api.rerender('d5f8dbd6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2Gy0OAKwBIgg4/JS/comp/GuestBox.vue"
export default component.exports